import { BasePropertyDTO } from 'business/models/Models';
import { GlobalPreferencesService } from 'business/services/GlobalPreferencesService';

const globalPrefService = new GlobalPreferencesService();
class SystemPropertiesCache {
  private cache: Record<string, BasePropertyDTO> = {};
  private pending: Record<string, Promise<BasePropertyDTO>> = {};

  async get(name: string): Promise<BasePropertyDTO> {
    // If cached, return immediately
    if (name in this.cache) {
      return this.cache[name];
    }

    // If already being fetched, return existing promise
    if (name in this.pending) {
      return this.pending[name];
    }

    const fetchPromise = globalPrefService
      .getProperty(name)
      .then(async (res) => {
        if (!res) {
          throw new Error(`Failed to load setting ${name}`);
        }
        this.cache[name] = res;
        delete this.pending[name];
        return res;
      })
      .catch((err) => {
        delete this.pending[name];
        console.error(err);
        return null;
      });

    this.pending[name] = fetchPromise;
    return fetchPromise;
  }

  // optional: clear cache or preload
  clear(name?: string) {
    if (name) {
      delete this.cache[name];
    } else {
      this.cache = {};
    }
  }
}

export const systemPropertiesCache = new SystemPropertiesCache();
